import { useEffect, useRef } from "react";
import PosPage from "./Pages/PosPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from ".";
import { SET_DB } from "./Features/database";
//@ts-ignore
import PouchDB from "pouchdb";
import LoginPage from "./Pages/LoginPage";
import { SET_POS_CONFIG } from "./Features/leftBarHeader";
import { loadPosConfig } from "./utils/configLoader";
import { initializeBaseService } from "./assets/BaseService";
import { SET_ROUTE } from "./Features/rightBarHeader";

function App(): JSX.Element {
  const appRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const db = useSelector((state: RootState) => state.database.db);
  const route = useSelector((state: RootState) => state.header.route);
  const token = localStorage.getItem("access_token");
  const selectedHeader = useSelector(
    (state: RootState) => state.leftHeader.selectedHeader
  );

  const screenFull = selectedHeader === "Orders";
  useEffect(() => {
    const loadConfigAndInitialize = async () => {
      try {
        const config = await initializeBaseService();
        const formattedConfig = await loadPosConfig();
        console.log("Formatted POS Config:", formattedConfig);
        dispatch(SET_POS_CONFIG(formattedConfig));

        if (token && formattedConfig.permissions) {
          const defaultPage = formattedConfig.defaultLandingPage || "posPage";
          const pageRouteMap: Record<string, string> = {
            posPage: "/PosPage",
            kdsPage: "/PosPage/KDSPage",
            reservationPage: "/PosPage/ReservationPage",
            addExpensePage: "/PosPage/AddExpensePage",
            orderListingPage: "/PosPage/OrderListingPage",
            priceCheckerPage: "/PosPage/PriceCheckerPage",
            kdsOrdersPage: "/PosPage/KDSOrders",
          };

          if (
            formattedConfig.permissions[defaultPage] &&
            pageRouteMap[defaultPage]
          ) {
            dispatch(SET_ROUTE(pageRouteMap[defaultPage]));
          } else {
            // Find first available page
            const availablePage = Object.keys(formattedConfig.permissions).find(
              (page) => formattedConfig.permissions[page] && pageRouteMap[page]
            );
            if (availablePage && pageRouteMap[availablePage]) {
              dispatch(SET_ROUTE(pageRouteMap[availablePage]));
            }
          }
        }
      } catch (error) {
        console.error("Failed to load config and initialize services:", error);
      }
    };

    loadConfigAndInitialize();
  }, [dispatch, token]);

  useEffect(() => {
    if (db === null) {
      //@ts-ignore
      dispatch(SET_DB(new PouchDB("orders")));
    }
  }, []);

  return (
    <div className={`h-[100%] ${screenFull ? "" : "md:h-screen"}`}>
      <div className="bg-white h-[100%]" ref={appRef}>
        {route === "" && <LoginPage />}
        {route.search("/PosPage") >= 0 && <PosPage elementRef={appRef} />}
      </div>
    </div>
  );
}

export default App;
